
/* Dutchline Universal Size Finder V3 — Clean Result */

(function () {
  'use strict';

  if (window.__dlSizeFinderUniversal) return;
  window.__dlSizeFinderUniversal = true;

  const FACTORY_CHARTS = {
    "3484": {
      "name": "Fur Jacket",
      "kind": "jacket",
      "cut": "relaxed",
      "measurements": {
        "S": {"length":66,"width":66},
        "M": {"length":67,"width":67},
        "L": {"length":70,"width":70},
        "XL": {"length":72,"width":72},
        "2XL": {"length":74,"width":74}
      },
      "needsVerification": false
    },
    "2027004": {
      "name": "Gabardine Jacket",
      "kind": "jacket",
      "cut": "regular",
      "measurements": {
        "S": {"length":63,"width":60},
        "M": {"length":65,"width":62},
        "L": {"length":67,"width":64},
        "XL": {"length":68,"width":65},
        "2XL": {"length":71,"width":67}
      },
      "needsVerification": false
    },
    "3486": {
      "name": "Cashmere Jacket",
      "kind": "jacket",
      "cut": "regular",
      "measurements": {
        "S": {"length":59,"width":61},
        "M": {"length":61,"width":63},
        "L": {"length":65,"width":64},
        "XL": {"length":67,"width":67},
        "2XL": {"length":70,"width":71}
      },
      "needsVerification": false
    },
    "2220": {
      "name": "Undershirt",
      "kind": "undershirt",
      "cut": "regular",
      "measurements": {
        "S": {"length":65,"chest":48},
        "M": {"length":66,"chest":50},
        "L": {"length":68,"chest":53},
        "XL": {"length":71,"chest":55},
        "2XL": {"length":73,"chest":56}
      },
      "needsVerification": false
    },
    "3261": {
      "name": "Trousers 3261 / 3262",
      "kind": "trousers",
      "cut": "relaxed",
      "measurements": {
        "S": {"waist_stretched":55,"thigh":35,"outseam":104,"leg_opening":23},
        "M": {"waist_stretched":57,"thigh":36,"outseam":107,"leg_opening":24},
        "L": {"waist_stretched":60,"thigh":38,"outseam":108,"leg_opening":25},
        "XL": {"waist_stretched":62,"thigh":40,"outseam":109,"leg_opening":25},
        "2XL": {"waist_stretched":64,"thigh":41,"outseam":110,"leg_opening":25}
      },
      "needsVerification": false
    },
    "3262": {
      "name": "Trousers 3261 / 3262",
      "kind": "trousers",
      "cut": "relaxed",
      "measurements": {
        "S": {"waist_stretched":55,"thigh":35,"outseam":104,"leg_opening":23},
        "M": {"waist_stretched":57,"thigh":36,"outseam":107,"leg_opening":24},
        "L": {"waist_stretched":60,"thigh":38,"outseam":108,"leg_opening":25},
        "XL": {"waist_stretched":62,"thigh":40,"outseam":109,"leg_opening":25},
        "2XL": {"waist_stretched":64,"thigh":41,"outseam":110,"leg_opening":25}
      },
      "needsVerification": false
    },
    "4581": {
      "name": "Box Fit Hoodie",
      "kind": "hoodie",
      "cut": "boxy",
      "measurements": {
        "S": {"length":60,"chest":61},
        "M": {"length":62,"chest":65},
        "L": {"length":64,"chest":66},
        "XL": {"length":66,"chest":70},
        "2XL": {"length":68,"chest":71}
      },
      "needsVerification": false
    },
    "4351": {
      "name": "Round Neck 4351",
      "kind": "hoodie",
      "cut": "regular",
      "measurements": {
        "S": {"length":63,"chest":62},
        "M": {"length":65,"chest":64},
        "L": {"length":67,"chest":66},
        "XL": {"length":69,"chest":61},
        "2XL": {"length":70,"chest":62}
      },
      "needsVerification": true
    },
    "4590": {
      "name": "Zip Hoodie",
      "kind": "hoodie",
      "cut": "relaxed",
      "measurements": {
        "S": {"length":61,"chest":62},
        "M": {"length":62,"chest":64},
        "L": {"length":63,"chest":68},
        "XL": {"length":67,"chest":69},
        "2XL": {"length":68,"chest":73}
      },
      "needsVerification": false
    },
    "4580": {
      "name": "Hoodie 4580",
      "kind": "hoodie",
      "cut": "relaxed",
      "measurements": {
        "S": {"length":63,"chest":68},
        "M": {"length":66,"chest":69},
        "L": {"length":68,"chest":70},
        "XL": {"length":71,"chest":73},
        "2XL": {"length":71,"chest":65}
      },
      "needsVerification": true
    },
    "4350": {
      "name": "Hoodie 4350",
      "kind": "hoodie",
      "cut": "relaxed",
      "measurements": {
        "S": {"length":63,"chest":62},
        "M": {"length":64,"chest":65},
        "L": {"length":66,"chest":67},
        "XL": {"length":68,"chest":70},
        "2XL": {"length":71,"chest":72}
      },
      "needsVerification": false
    }
  };

  const ALPHA = [
    'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'
  ];

  const HEIGHT_ANCHORS = [
    158, 165, 173, 180, 187, 194, 200, 205
  ];

  const WEIGHT_ANCHORS = [
    52, 60, 72, 83, 96, 112, 130, 148
  ];

  const FIELDS = {
    chest: 'Flat chest',
    width: 'Width (factory label)',
    length: 'Body length',
    waist_flat: 'Flat waist',
    waist_stretched: 'Waist stretched',
    hip_flat: 'Flat hip',
    thigh: 'Thigh',
    outseam: 'Outseam',
    inseam: 'Inseam',
    leg_opening: 'Leg opening',
    sleeve: 'Sleeve',
    shoulder: 'Shoulder'
  };

  function parseJSON(raw, fallback) {
    if (!raw) return fallback;

    try {
      let parsed = JSON.parse(raw);

      if (
        typeof parsed === 'string' &&
        /^[\[{]/.test(parsed.trim())
      ) {
        parsed = JSON.parse(parsed);
      }

      return parsed == null ? fallback : parsed;

    } catch (_) {
      return fallback;
    }
  }

  function normalizeSize(raw) {
    let s = String(raw == null ? '' : raw)
      .trim()
      .toUpperCase()
      .replace(/\s+/g, '');

    const aliases = {
      EXTRASMALL: 'XS',
      XSMALL: 'XS',
      SMALL: 'S',
      MEDIUM: 'M',
      LARGE: 'L',
      EXTRALARGE: 'XL',
      XXL: '2XL',
      XXLARGE: '2XL',
      XXXL: '3XL',
      XXXXL: '4XL',
      '2X': '2XL',
      '3X': '3XL',
      '4X': '4XL',
      XXXLARGE: '3XL',
      XXXXLARGE: '4XL'
    };

    s = aliases[s] || s;

    if (ALPHA.includes(s)) return s;

    const match =
      /^(?:W|WAIST)?(2[6-9]|[3-4]\d|50)(?:$|\/|L\d|IN$|INCH$)/.exec(s);

    return match ? String(Number(match[1])) : null;
  }

  function compareSizes(a, b) {
    const na = Number(a);
    const nb = Number(b);

    if (
      Number.isFinite(na) &&
      Number.isFinite(nb)
    ) {
      return na - nb;
    }

    if (
      !Number.isFinite(na) &&
      !Number.isFinite(nb)
    ) {
      return ALPHA.indexOf(a) - ALPHA.indexOf(b);
    }

    return Number.isFinite(na) ? 1 : -1;
  }

  function modelFrom(root) {
    const codes = Object.keys(FACTORY_CHARTS)
      .sort((a, b) => b.length - a.length);

    const find = (input, exact) => {
      const source = String(input || '')
        .trim()
        .toLowerCase();

      for (const code of codes) {
        if (exact) {
          if (
            [
              code,
              'model-' + code,
              'model_' + code,
              'model:' + code,
              'size-' + code
            ].includes(source)
          ) {
            return code;
          }
        } else {
          if (
            new RegExp(
              '(?:^|[^0-9])' + code + '(?![0-9])'
            ).test(source)
          ) {
            return code;
          }
        }
      }

      return null;
    };

    const explicit = find(root.dataset.modelCode, true);

    if (explicit) return explicit;

    for (const tag of (root.dataset.tags || '').split('|')) {
      const match = find(tag, true);
      if (match) return match;
    }

    for (const value of [
      root.dataset.productTitle,
      root.dataset.productHandle,
      root.dataset.skus
    ]) {
      const match = find(value, false);
      if (match) return match;
    }

    return null;
  }

  function inferCategory(root) {
    const forced = String(root.dataset.profile || '')
      .trim()
      .toLowerCase();

    if (
      ['tops', 'outerwear', 'bottoms', 'accessories']
        .includes(forced)
    ) {
      return forced;
    }

    const title = [
      root.dataset.productType,
      root.dataset.productTitle,
      root.dataset.tags
    ].join(' ').toLowerCase();

    if (
      /jeans|denim|pants|pant\b|bottoms?|trouser|jogger|sweatpant|shorts|cargo|بنطلون|جينز/.test(title)
    ) {
      return 'bottoms';
    }

    if (
      /jacket|coat|blazer|overshirt|windbreaker|جاكت|جاكيت/.test(title)
    ) {
      return 'outerwear';
    }

    if (
      /hoodie|sweater|shirt|crewneck|polo|tee|t-shirt|knit|sweatshirt|pullover|هودي|تيشيرت|قميص/.test(title)
    ) {
      return 'tops';
    }

    if (
      /shoe|sneaker|boot|belt|cap\b|hat\b|bag\b|sock|scarf|accessor|حذاء|كاب|شنطة/.test(title)
    ) {
      return 'accessories';
    }

    return 'tops';
  }

  function profileCut(root, chart) {
    const manually = String(root.dataset.cut || '')
      .trim()
      .toLowerCase();

    if (
      ['slim', 'regular', 'relaxed', 'oversized', 'boxy']
        .includes(manually)
    ) {
      return manually;
    }

    if (chart && chart.cut) return chart.cut;

    const s = (
      root.dataset.productTitle + ' ' +
      root.dataset.tags
    ).toLowerCase();

    if (/oversized|oversize|boxy|box.fit|baggy/.test(s)) {
      return 'oversized';
    }

    if (/slim|skinny|fitted/.test(s)) {
      return 'slim';
    }

    if (/relaxed|loose/.test(s)) {
      return 'relaxed';
    }

    return 'regular';
  }

  function isSizeOption(name) {
    return /size|waist|مقاس|المقاس|قياس/i
      .test(String(name || ''));
  }

  function identifySizeOption(optionNames, variants) {
    const named = optionNames.findIndex(isSizeOption);

    if (named >= 0) return named;

    const count = Math.max(
      0,
      ...variants.map(
        v => (v.options || []).length
      )
    );

    for (let i = 0; i < count; i++) {
      const vals = [
        ...new Set(
          variants.map(
            v => normalizeSize((v.options || [])[i])
          ).filter(Boolean)
        )
      ];

      if (vals.length >= 2) return i;
    }

    return -1;
  }

  function productSizes(root) {
    const variants = parseJSON(
      root.dataset.variants,
      []
    );

    const optionNames = parseJSON(
      root.dataset.options,
      []
    );

    if (
      !Array.isArray(variants) ||
      !Array.isArray(optionNames)
    ) {
      return {
        sizes: [],
        variants: [],
        sizeIndex: -1,
        optionNames: []
      };
    }

    const sizeIndex = identifySizeOption(
      optionNames,
      variants
    );

    const sizes = sizeIndex < 0
      ? []
      : [
          ...new Set(
            variants.map(
              v => normalizeSize(
                (v.options || [])[sizeIndex]
              )
            ).filter(Boolean)
          )
        ].sort(compareSizes);

    return {
      variants,
      optionNames,
      sizeIndex,
      sizes
    };
  }

  function customChart(root) {
    const raw = parseJSON(
      root.dataset.customChart,
      null
    );

    if (
      !raw ||
      typeof raw !== 'object' ||
      Array.isArray(raw) ||
      !raw.measurements ||
      typeof raw.measurements !== 'object'
    ) {
      return null;
    }

    const cleaned = {};

    Object.entries(raw.measurements)
      .forEach(([key, values]) => {
        const size = normalizeSize(key);

        if (
          !size ||
          !values ||
          typeof values !== 'object'
        ) {
          return;
        }

        const entry = {};

        Object.entries(values)
          .forEach(([field, val]) => {
            if (
              Object.prototype.hasOwnProperty.call(
                FIELDS,
                field
              ) &&
              typeof val === 'number' &&
              Number.isFinite(val) &&
              val > 0 &&
              val < 500
            ) {
              entry[field] = val;
            }
          });

        if (Object.keys(entry).length) {
          cleaned[size] = entry;
        }
      });

    if (!Object.keys(cleaned).length) return null;

    return {
      name: String(
        raw.name ||
        root.dataset.productTitle ||
        'Product'
      ),
      kind:
        raw.kind === 'bottoms' ||
        raw.kind === 'trousers'
          ? 'trousers'
          : 'tops',
      cut: String(raw.cut || ''),
      measurements: cleaned,
      needsVerification:
        raw.needsVerification === true,
      source: 'product'
    };
  }

  function findChart(root, sizes) {
    const specific = customChart(root);

    if (specific) return specific;

    const code = modelFrom(root);

    const factory = code
      ? FACTORY_CHARTS[code]
      : null;

    if (!factory) return null;

    if (
      sizes.length &&
      !sizes.some(
        size => Object.prototype.hasOwnProperty.call(
          factory.measurements,
          size
        )
      )
    ) {
      return null;
    }

    return Object.assign(
      { source: 'factory', code },
      factory
    );
  }

  function inStock(size, data) {
    return data.variants.some(
      v =>
        v.available === true &&
        normalizeSize(
          (v.options || [])[data.sizeIndex]
        ) === size
    );
  }

  function currentSelectedVariantId(root) {
    const queryId = new URLSearchParams(
      window.location.search
    ).get('variant');

    return queryId ||
      root.dataset.selectedVariantId;
  }

  function sizeIndexFromAnchors(x, anchors) {
    if (x <= anchors[0]) return 0;

    if (x >= anchors[anchors.length - 1]) {
      return anchors.length - 1;
    }

    for (let i = 0; i < anchors.length - 1; i++) {
      if (x <= anchors[i + 1]) {
        return i + (
          (x - anchors[i]) /
          (anchors[i + 1] - anchors[i])
        );
      }
    }

    return anchors.length - 1;
  }

  function bodyTarget(
    height,
    weight,
    build,
    preferredFit
  ) {
    const buildChange =
      build === 'slim'
        ? -0.35
        : build === 'broad'
          ? 0.35
          : 0;

    const fitChange =
      preferredFit === 'closer'
        ? -0.55
        : preferredFit === 'roomier'
          ? 0.55
          : 0;

    return (
      0.35 * sizeIndexFromAnchors(
        height,
        HEIGHT_ANCHORS
      ) +
      0.65 * sizeIndexFromAnchors(
        weight,
        WEIGHT_ANCHORS
      ) +
      buildChange +
      fitChange
    );
  }

  function recommend(
    eligibleSizes,
    allSizes,
    data,
    chart,
    category,
    numericSystem,
    inputs
  ) {
    if (!eligibleSizes.length) return null;

    const sizes = allSizes;

    const numeric = sizes.every(
      s => /^\d+$/.test(s)
    );

    const target = bodyTarget(
      inputs.height,
      inputs.weight,
      inputs.build,
      inputs.fit
    );

    const scored = eligibleSizes.map(size => {
      const i = sizes.indexOf(size);

      const pos = numeric
        ? (
            sizes.length === 1
              ? target
              : 1 + (
                  i * (ALPHA.length - 3)
                ) / (sizes.length - 1)
          )
        : ALPHA.indexOf(size);

      let score = Math.pow(
        pos - target,
        2
      );

      const dims =
        chart && chart.measurements[size];

      if (
        dims &&
        inputs.chest &&
        category !== 'bottoms'
      ) {
        const chestFlat = dims.chest;

        if (chestFlat) {
          const ease =
            chestFlat * 2 - inputs.chest;

          const min =
            chart.cut === 'slim'
              ? 2
              : chart.cut === 'oversized' ||
                chart.cut === 'boxy'
                  ? 12
                  : 6;

          if (ease < min) {
            score += 5 + Math.pow(
              (min - ease) / 5,
              2
            );
          }
        }
      }

      if (
        dims &&
        inputs.waist &&
        category === 'bottoms' &&
        dims.waist_flat
      ) {
        const waistEase =
          dims.waist_flat * 2 -
          inputs.waist;

        if (waistEase < 2) {
          score += 6 + Math.pow(
            (2 - waistEase) / 4,
            2
          );
        } else {
          score += Math.pow(
            (waistEase - 4) / 25,
            2
          );
        }
      } else if (
        numeric &&
        numericSystem === 'waist_inches' &&
        inputs.waist
      ) {
        const inches =
          inputs.waist / 2.54;

        score += Math.pow(
          (Number(size) - inches) / 1.8,
          2
        ) * 1.4;
      }

      return {
        size,
        score,
        i
      };
    });

    scored.sort(
      (a, b) =>
        a.score - b.score ||
        a.i - b.i
    );

    return scored[0].size;
  }

  function makeText(
    parent,
    tag,
    value,
    className
  ) {
    const node = document.createElement(tag);

    node.textContent =
      value == null ? '' : String(value);

    if (className) {
      node.className = className;
    }

    parent.appendChild(node);

    return node;
  }

  function dimensionColumns(chart) {
    if (!chart) return [];

    const keys = [
      ...new Set(
        Object.values(chart.measurements)
          .flatMap(v => Object.keys(v))
      )
    ];

    return Object.keys(FIELDS)
      .filter(key => keys.includes(key))
      .map(key => [
        key,
        FIELDS[key]
      ]);
  }

  function measuredDescription(chart, size) {
    const dims =
      chart && chart.measurements[size];

    if (!dims) return '';

    return Object.keys(FIELDS)
      .filter(
        k => Object.hasOwn(dims, k)
      )
      .map(
        k => (
          FIELDS[k] + ': ' +
          dims[k] + ' cm'
        )
      )
      .join(' · ') + '.';
  }

  function shortFitLabel(
    size,
    suggested,
    orderedSizes
  ) {
    if (!suggested) return 'Size option';

    const difference =
      orderedSizes.indexOf(size) -
      orderedSizes.indexOf(suggested);

    if (difference < 0) {
      return 'Closer fit';
    }

    if (difference > 0) {
      return 'Roomier fit';
    }

    return 'Recommended';
  }

  function drawTable(
    root,
    data,
    chart,
    sizes,
    recommended
  ) {
    const head = root.querySelector(
      '[data-dl-chart-head]'
    );

    const body = root.querySelector(
      '[data-dl-chart-body]'
    );

    const notes = root.querySelector(
      '[data-dl-chart-notes]'
    );

    const details = root.querySelector(
      '[data-dl-chart-details]'
    );

    head.replaceChildren();
    body.replaceChildren();

    if (
      !chart ||
      !dimensionColumns(chart).length ||
      !sizes.some(
        s => chart.measurements[s]
      )
    ) {
      details.hidden = true;
      return;
    }

    details.hidden = false;

    const columns = dimensionColumns(chart);

    const row = document.createElement('tr');

    makeText(row, 'th', 'Size');

    columns.forEach(
      col => makeText(
        row,
        'th',
        col[1]
      )
    );

    head.appendChild(row);

    sizes.forEach(size => {
      if (
        root.dataset.hideUnavailable === 'true' &&
        data.sizes.length &&
        !inStock(size, data)
      ) {
        return;
      }

      const tr = document.createElement('tr');

      if (size === recommended) {
        tr.setAttribute(
          'data-dl-picked',
          ''
        );
      }

      if (
        data.sizes.length &&
        !inStock(size, data)
      ) {
        tr.classList.add(
          'dl-size-finder__soldout'
        );
      }

      makeText(tr, 'th', size);

      const dims =
        chart.measurements[size] || {};

      columns.forEach(col => {
        makeText(
          tr,
          'td',
          dims[col[0]] == null
            ? '—'
            : String(dims[col[0]])
        );
      });

      body.appendChild(tr);
    });

    if (
      chart.kind === 'trousers' &&
      columns.some(
        c => c[0] === 'waist_stretched'
      )
    ) {
      notes.textContent =
        'All measurements in cm. The waistband measurement is stretched, not relaxed. Compare with a pair you own.';
    } else if (
      columns.some(
        c => c[0] === 'width'
      )
    ) {
      notes.textContent =
        'All measurements in cm. “Width” is the factory label; confirm how it was measured before using it for a precise fit.';
    } else {
      notes.textContent =
        'All measurements in cm, based on the supplied product chart.';
    }
  }

  function showNearby(
    root,
    sizes,
    recommendation,
    data
  ) {
    const wrap = root.querySelector(
      '[data-dl-nearby]'
    );

    const holder = root.querySelector(
      '[data-dl-nearby-items]'
    );

    holder.replaceChildren();

    const current =
      sizes.indexOf(recommendation);

    if (current < 0) {
      wrap.hidden = true;
      return;
    }

    const near = [
      current - 1,
      current,
      current + 1
    ]
      .filter(
        i => i >= 0 &&
        i < sizes.length
      )
      .map(i => sizes[i]);

    wrap.hidden = near.length < 2;

    near.forEach(size => {
      const item = makeText(
        holder,
        'div',
        '',
        'dl-size-finder__nearby-item'
      );

      if (size === recommendation) {
        item.classList.add(
          'dl-size-finder__nearby-item--picked'
        );
      }

      makeText(
        item,
        'strong',
        size
      );

      makeText(
        item,
        'span',
        shortFitLabel(
          size,
          recommendation,
          sizes
        )
      );

      if (!inStock(size, data)) {
        item.classList.add(
          'dl-size-finder__nearby-item--soldout'
        );

        makeText(
          item,
          'small',
          'Sold out'
        );
      }
    });
  }

  function setup(root) {
    if (
      root.dataset.dlInitialized === 'true'
    ) {
      return;
    }

    root.dataset.dlInitialized = 'true';

    const data = productSizes(root);
    const chart = findChart(
      root,
      data.sizes
    );

    const category = inferCategory(root);
    const cut = profileCut(root, chart);

    const numericSystem =
      root.dataset.numericSystem === 'waist_inches'
        ? 'waist_inches'
        : 'rank';

    const sizes = data.sizes.slice();

    const displaySizes = sizes.length
      ? sizes
      : (
          chart
            ? Object.keys(
                chart.measurements
              ).sort(compareSizes)
            : []
        );

    const recommendedOptions = sizes.filter(
      size => inStock(size, data)
    );

    const dialog = root.querySelector(
      '[data-dl-dialog]'
    );

    const form = root.querySelector(
      '[data-dl-form]'
    );

    const formView = root.querySelector(
      '[data-dl-form-view]'
    );

    const result = root.querySelector(
      '[data-dl-result]'
    );

    const unavailable = root.querySelector(
      '[data-dl-unavailable]'
    );

    const unavailableMessage = root.querySelector(
      '[data-dl-unavailable-message]'
    );

    const model = root.querySelector(
      '[data-dl-model]'
    );

    const validation = root.querySelector(
      '[data-dl-validation]'
    );

    const inline = root.querySelector(
      '[data-dl-inline]'
    );

    const fitLabel = {
      slim: 'Slim',
      regular: 'Regular',
      relaxed: 'Relaxed',
      oversized: 'Oversized',
      boxy: 'Boxy'
    }[cut] || 'Regular';

    let lastRecommendation = null;

    model.textContent = (
      root.dataset.productTitle ||
      'This product'
    ) + ' · ' + fitLabel + ' fit';

    let error = '';

    if (
      chart &&
      chart.needsVerification
    ) {
      error =
        'We are checking this product’s factory measurements. Please use the size chart below or contact Dutchline for fitting advice.';
    } else if (!sizes.length) {
      error =
        'This product has no recognizable size options. Please check its product details for fit information.';
    } else if (
      category === 'accessories'
    ) {
      error =
        'Height and weight do not reliably predict accessory or footwear sizes. Please use the product measurements.';
    } else if (
      sizes.length < 2
    ) {
      error =
        'This product has one size option. Please check the product details for its measurements.';
    } else if (
      sizes.some(
        s => /^\d+$/.test(s)
      ) &&
      sizes.some(
        s => !/^\d+$/.test(s)
      )
    ) {
      error =
        'This product uses a mixture of size formats. We cannot recommend a size until its variants are corrected.';
    } else if (
      !recommendedOptions.length
    ) {
      error =
        'This product is currently sold out in every size.';
    }

    if (error) {
      formView.hidden = true;
      unavailable.hidden = false;
      unavailableMessage.textContent = error;
    }

    drawTable(
      root,
      data,
      chart,
      displaySizes,
      null
    );

    const closeDialog = () => {
      if (
        typeof dialog.close === 'function'
      ) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    };

    root.querySelector(
      '[data-dl-open]'
    ).addEventListener('click', () => {
      if (
        typeof dialog.showModal === 'function'
      ) {
        dialog.showModal();
      } else {
        dialog.setAttribute(
          'open',
          ''
        );
      }
    });

    root.querySelector(
      '[data-dl-close]'
    ).addEventListener(
      'click',
      closeDialog
    );

    dialog.addEventListener(
      'click',
      event => {
        if (
          event.target === dialog
        ) {
          closeDialog();
        }
      }
    );

    root.querySelector(
      '[data-dl-edit]'
    ).addEventListener(
      'click',
      () => {
        result.hidden = true;
        formView.hidden = false;
        form.elements.height.focus();
      }
    );

    form.addEventListener(
      'submit',
      event => {
        event.preventDefault();

        const height = Number(
          form.elements.height.value
        );

        const weight = Number(
          form.elements.weight.value
        );

        const valid =
          form.elements.height.value.trim() !== '' &&
          form.elements.weight.value.trim() !== '' &&
          Number.isFinite(height) &&
          height >= 120 &&
          height <= 225 &&
          Number.isFinite(weight) &&
          weight >= 30 &&
          weight <= 250;

        validation.hidden = valid;

        if (!valid) {
          validation.textContent =
            'Enter a height between 120–225 cm and weight between 30–250 kg.';
          return;
        }

        const inputs = {
          height,
          weight,
          fit: form.elements.fit.value,
          build: 'average',
          chest: null,
          waist: null
        };

        const recommendation = recommend(
          recommendedOptions,
          sizes,
          data,
          chart,
          category,
          numericSystem,
          inputs
        );

        if (!recommendation) return;

        lastRecommendation = recommendation;

        formView.hidden = true;
        result.hidden = false;

        root.querySelector(
          '[data-dl-recommended]'
        ).textContent = recommendation;

        // REMOVE ALL THREE UNWANTED MESSAGES
        const summary = root.querySelector(
          '[data-dl-result-summary]'
        );

        summary.textContent = '';
        summary.hidden = true;

        const hasChart = Boolean(
          chart &&
          !chart.needsVerification &&
          chart.measurements[recommendation]
        );

        const confidence = root.querySelector(
          '[data-dl-confidence]'
        );

        confidence.textContent = hasChart
          ? 'Product measurements are available below.'
          : '';

        confidence.hidden = !hasChart;

        const notice = root.querySelector(
          '[data-dl-result-notice]'
        );

        notice.textContent = hasChart
          ? (
              chart.kind === 'trousers' &&
              !chart.measurements[recommendation].waist_flat
                ? 'Waist fit is not verified from stretched-waist measurements. Compare your own trousers.'
                : 'Check measurements if you are between sizes; body proportions vary.'
            )
          : '';

        notice.hidden = !notice.textContent;

        showNearby(
          root,
          sizes,
          recommendation,
          data
        );

        drawTable(
          root,
          data,
          chart,
          displaySizes,
          recommendation
        );

        inline.hidden = false;

        inline.textContent =
          'Suggested size: ' +
          recommendation;

        dialog.scrollTop = 0;
      }
    );

    const section =
      root.closest('.shopify-section') ||
      root.closest('section') ||
      document;

    section.addEventListener(
      'change',
      event => {
        if (
          !lastRecommendation ||
          dialog.contains(event.target)
        ) {
          return;
        }

        const selected = normalizeSize(
          event.target.value
        );

        if (
          !selected ||
          !sizes.includes(selected)
        ) {
          return;
        }

        const fit = shortFitLabel(
          selected,
          lastRecommendation,
          sizes
        );

        inline.hidden = false;

        inline.textContent =
          selected === lastRecommendation
            ? 'Suggested size: ' +
              lastRecommendation
            : 'Suggested: ' +
              lastRecommendation +
              ' · Selected ' +
              selected +
              ' may fit ' +
              (
                fit === 'Closer fit'
                  ? 'closer'
                  : 'roomier'
              );
      }
    );
  }

  function init() {
    document.querySelectorAll(
      '[data-dl-size-finder]'
    ).forEach(setup);
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    init
  );
})();
